export const VISIBLE_TOASTS_AMOUNT = 3;

export const VIEWPORT_OFFSET = "32px";

export const TOAST_LIFETIME = 4000;

export const TOAST_WIDTH = 356;

export const GAP = 14;

export const SWIPE_TRESHOLD = 20;

export const TIME_BEFORE_UNMOUNT = 200;
